// @flow
import React from 'react';
import injectSheet from 'react-jss';
import {
  FONT_FAMILY_ROBOTO
} from 'shared/constants';

type Props = {
  classes: Object,
  rich_text: string,
  padding_type: string,
  text_line_height: string
};

function RichText({ rich_text, classes }: Props) {
  return (
    <article
      className={classes.article}
      dangerouslySetInnerHTML={{ __html: rich_text }}
    />
  );
}

const styles = {
  article: {
    fontFamily: FONT_FAMILY_ROBOTO,
    fontWeight: '300',
    fontSize: '17px',
    lineHeight: ({ text_line_height }) => text_line_height || '2',
    padding: (props) => {
      const { custom_padding: customPadding, padding_type: type } = props;

      // Custom padding overrides the padding type setting
      if (customPadding) {
        return customPadding;
      }

      return type === 'None' ? '0' : '26px 36px'
    },
    // Remove top/bottom margin for ul at the top or bottom of richtext
    '&> ul:nth-child(1)': {
      marginBlockStart: '0'
    },
    '&> ul:last-child': {
      marginBlockEnd: '0'
    },
    '&> h1': {
      fontWeight: '300',
      lineHeight: '2',
      fontSize: '26px'
    },
    '& h2': {
      fontWeight: '300',
      lineHeight: '2',
      fontSize: '22px'
    },
    '& h3': {
      fontWeight: '600',
      lineHeight: '1.75',
      fontSize: '13px',
      letterSpacing: '.1em'
    },
    '& h4': {
      fontSize: '12px',
      fontWeight: '600',
      letterSpacing: '.1em',
      display: 'flex',
      alignItems: 'center',
      textTransform: 'uppercase',
      '& a': {
        '&:after': {
          content: '"\\f178"',
          fontFamily: 'ff-icons',
          fontSize: '12px',
          marginLeft: '10px'
        }
      }
    },
    '&> blockquote': {
      fontWeight: '300',
      fontFamily: FONT_FAMILY_ROBOTO,
      fontSize: '40px',
      letterSpacing: '1px',
      lineHeight: '1.5',
      width: '90%',
      marginTop: '90px',
      marginBottom: '90px',
      position: 'relative',
      marginLeft: '0',
      '&:after': {
        position: 'absolute',
        left: '0',
        right: '0',
        bottom: '-60px',
        content: '"\\e902"',
        textAlign: 'center',
        fontFamily: 'ff-icons',
        fontSize: '36px'
      }
    },
    '&> p': {
      margin: '0',
      width: 'auto'
    },
    '& a': {
      textDecoration: 'none',
      color: 'black',
      cursor: 'pointer',
      overflowWrap: 'break-word',
      wordWrap: 'break-word', // break-word support for legacy browsers
    },
    '& strong': {
      fontWeight: '600'
    },
    '@media(max-width: 960px)': {
      '&> *:not(ul):not(ol)': {
        width: '100%'
      },
    }
  }
};

export default injectSheet(styles)(RichText);
